import React from "react";
import { ToastContainer } from "react-toastify";
import { AddEvent } from "../components/ExternalEvents/AddEvent";

export const EventsAdd = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddEvent />
        </div>
      </div>
    </div>
  );
};
